import React from 'react';
import analytics from '../../lib/analytics';
import SignUpForm from '../common/SignUpForm';

const AiBetaProgram = () => {
  analytics.trackEvent({ eventName: 'AiBeta' });
  return (
    <div className="LandingPage">
      <SignUpForm
        campaign={443}
        header="Marbleverse AI Beta"
        callToAction="Join the beta list. Selected users will be invited in stages as we open up the program."
        buttonText="Join the Beta"
      >
        <h1>The next chapter of Marbleverse starts here.</h1>
        <p>AI-powered features are coming to make Marbleverse more personal, creative, and fun.</p>
      </SignUpForm>
    </div>
  );
};

export default AiBetaProgram;
